"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddonPriceTag = void 0;
const react_1 = __importDefault(require("react"));
const react_number_format_1 = require("react-number-format");
/**
 * Formats the price model as a price tag like "CHF 20 pro Person (halber Tag)"
 */
const AddonPriceTag = (props) => {
    if (props.priceModel.length === 0) {
        // No price defined.
        return react_1.default.createElement(react_1.default.Fragment, null, "Variabler Preis");
    }
    else if (props.priceModel.length === 1) {
        // Test if it is includeded at no cost.
        if (props.priceModel[0].price === 0) {
            return react_1.default.createElement(react_1.default.Fragment, null, "Inklusive");
        }
        // Linear price.
        const halfDayText = "halber Tag (unter 5h)";
        const fullDayText = "ganzer Tag (ab 5h)";
        let unitText = "";
        if (props.maxQuantity > 1 && props.unitSingular) {
            unitText = `pro ${props.unitSingular}`;
        }
        const priceElement = (react_1.default.createElement(react_1.default.Fragment, null,
            "CHF",
            " ",
            react_1.default.createElement(react_number_format_1.NumericFormat, { className: "", displayType: "text", thousandSeparator: "'", decimalSeparator: ".", decimalScale: 2, 
                // Only show decimal numbers if it has decimals (safes space).
                fixedDecimalScale: !Number.isInteger(props.priceModel[0].price), value: props.priceModel[0].price })));
        if (props.priceModel[0].fullDayPrice != null) {
            // Indicate different prices for half/full day.
            const fullDayPriceElement = (react_1.default.createElement(react_1.default.Fragment, null,
                "CHF",
                " ",
                react_1.default.createElement(react_number_format_1.NumericFormat, { className: "", displayType: "text", thousandSeparator: "'", decimalSeparator: ".", decimalScale: 2, 
                    // Only show decimal numbers if it has decimals (safes space).
                    fixedDecimalScale: !Number.isInteger(props.priceModel[0].fullDayPrice), value: props.priceModel[0].fullDayPrice })));
            return (react_1.default.createElement("table", null,
                react_1.default.createElement("tbody", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("td", { className: "price text-nowrap pr-1 pb-1" }, priceElement),
                        react_1.default.createElement("td", { className: "description small pl-1 pb-1" },
                            unitText && (react_1.default.createElement(react_1.default.Fragment, null,
                                unitText,
                                react_1.default.createElement("br", null))),
                            halfDayText)),
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("td", { className: "price text-nowrap pr-1" }, fullDayPriceElement),
                        react_1.default.createElement("td", { className: "description small pl-1" },
                            unitText && (react_1.default.createElement(react_1.default.Fragment, null,
                                unitText,
                                react_1.default.createElement("br", null))),
                            fullDayText)))));
        }
        else {
            // Show only single element for the price.
            return (react_1.default.createElement("div", { className: "price" },
                priceElement,
                " ",
                react_1.default.createElement("small", { className: "description" }, unitText)));
        }
    }
    else {
        // Multiple price levels.
        return react_1.default.createElement(react_1.default.Fragment, null, "Variabler Preis");
    }
};
exports.AddonPriceTag = AddonPriceTag;
